<template>
  <div class="area-filter" :class="{ 'move-only': !areaFilterConfig.apply_to_map }" v-if="areaFilterConfig.enabled">
    <template v-if="areaFilterConfig.apply_to_map">
      <area-filter-selector
        :point-zoom="areaFilterConfig.point_zoom"
        :points-max-zoom="areaFilterConfig.points_max_zoom"
        :pref-config="areaFilterConfig.prefs.filter"
        :fixed-location-prefs="areaFilterConfig.prefs.fixed_location"
        :city-config="areaFilterConfig.cities.filter"
        apply-filter-to-map
      ></area-filter-selector>
    </template>
    <template v-else>
      <button class="uk-button uk-button-small" uk-toggle="target: #area-filter-modal" v-wave>{{ messages.map_select_area_and_pan_to }}</button>
      <div id="area-filter-modal" uk-modal>
        <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
          <div class="uk-modal-header uk-flex uk-flex-between">
            <p class="uk-modal-title-small">{{ messages.map_select_area_and_pan_to }}</p>
            <button class="uk-modal-close uk-modal-close-relative" type="button" uk-close></button>
          </div>
          <div class="uk-modal-body">
            <area-filter-selector
              :point-zoom="areaFilterConfig.point_zoom"
              :points-max-zoom="areaFilterConfig.points_max_zoom"
              :pref-config="areaFilterConfig.prefs.filter"
              :fixed-location-prefs="areaFilterConfig.prefs.fixed_location"
              :city-config="areaFilterConfig.cities.filter"
              @on-moved="onMoved"
            ></area-filter-selector>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import uikit from 'uikit'
import AreaFilterSelector from '@/components/map/Panel/AreaFilterSelector.vue'

const messages = storelocator.messages

/**
 * 地域での絞り込みの設定
 */
const areaFilterConfig = storelocator?.area_filter

/**
 * 地域での絞り込みのモーダル
 * マップでは絞り込まない場合に移動するために利用
 */
let areaFilterModal: uikit.UIkitModalElement | null = null

onMounted(() => {
  areaFilterModal = uikit.modal(`#area-filter-modal`)
})

/**
 * 地域を選択して移動した時の処理
 *
 * @param prefName 都道府県名
 * @param cityName 市区町村名
 */
const onMoved = (prefName: string, cityName: string) => {
  areaFilterModal.hide()
  uikit.notification({
    message: messages.common_moved_to_area.replace('{area}', prefName + (cityName ? ' ' + cityName : '')),
    pos: 'top-center',
    timeout: 3000
  })
}
</script>

<style lang="scss" scoped>
.area-filter.move-only {
  button {
    background-color: #fff;
    border-radius: 15px;
    border: 1px solid #eee;
    height: 30px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

#area-filter-modal {
  .uk-modal-dialog {
    width: 400px;
    padding: 0;
    .uk-modal-header {
      // font-size: 1.25rem;
      padding: 1rem 1.5rem 1rem 1rem;
      .uk-modal-title-small {
        color: #666;
        font-size: 1.125rem;
      }
    }
  }
}
</style>
